import "core-js/modules/es.number.constructor.js";
import { MINIMUM_DEGREE_FOR_STANDARDIZED_TESTS } from "../Common/Constants";
export var askForStandardizedTests = function askForStandardizedTests(degree) {
  return degree && Number(degree) >= MINIMUM_DEGREE_FOR_STANDARDIZED_TESTS;
};
var makeViewable = function makeViewable(node) {
  return node.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
};
export var scrollIfNeeded = function scrollIfNeeded(node) {
  var isMobile = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var buttonHeight = isMobile ? 56 : 0;
  var windowHeight = window.innerHeight - buttonHeight;
  var isViewable = (node === null || node === void 0 ? void 0 : node.getBoundingClientRect().bottom) <= windowHeight;
  if (node && !isViewable) makeViewable(node);
};

// Fisher-Yates algorithm
export var shuffleArray = function shuffleArray(array) {
  for (var i = array.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var temp = array[i];
    array[i] = array[j];
    array[j] = temp;
  }
};